<template>
  <div class="credit-note-wrap">
    <CCard>
      <CCardHeader class="grey-header d-flex">
        <div class="row flex-flow-column">
          <CCol>
            <strong>{{$t('systemTopUpPage.systemTopUpTitle')}}</strong>
          </CCol>
          <p
            class="desc"
          >{{$t('systemTopUpPage.systemTopUpDesc')}}</p>
        </div>
      </CCardHeader>
      <CContainer>
        <CCardBody class="max-w-1100 m-auto">
          <ValidationObserver v-slot="{ handleSubmit }">
            <CForm @submit.prevent="handleSubmit(onTopUpDetConfirm)" class="topup-form-wrapper" >
                <CRow>

                   <div class=" col-form-label col-sm-12 topup-form-wrapper">
              <cAgent
                  :label="$t('systemTopUpPage.selectAgentName')"
                v-model="agency"
                :agentType="agentType"
               :isMultiple="false"
                v-on:input="getAgentDetails"
                class="bs-input"
              />
                   </div>
                  </CRow>
              
              <div v-if="agencyDet!=null" class="row" >
               <div class="col-md-6">
                 <cAgentDetails :agencyDet="agencyDet"/>
               </div>
               
                <div class="col-md-6" v-if="isReCreateComp">
                  <div v-if="balanceDetail">
                  <cAgentBalanceDetail :balanceDet="balanceDetail"/>
                 
                  <!-- <cAgentBookingDetail :agentBookingDet="agentBookingDetail" /> -->
                     <cAgentBookingDetail v-if="isCurrChanged" :balanceDet="balanceDetail"/>
                     </div>

                     <br/>
                 
                  <div class="sys-topup-wrapper"> <div class="available-credits">
                    <label class="title">{{$t('systemTopUpPage.topUpAmt')}}</label>
                  </div>
                    <div class="box-shadow-card d-flex-root" v-if="isCurrChanged">


                      <div class="topup-amount-wrapper d-flex">
                        <div class="currency-field" v-if="isCurrChanged">
                          <cDropDown
                            class="dpTopalign"
                            v-model="currencyCode"
                            :ctrlName="'code'"
                            :ctrlCode="'name'"
                            :isShowCode="false"
                            :isMultiple="false"
                            :isSearchable="true"
                            :url="getCurrencyCodeURL()"
                            rules="required"  
                            :selValue="currencyCode"
                            @input="onSelectedCurrency"
                          />
                        </div>

                        <div class="inner-label-none mt-2px w-100">
                              <!-- <div @change="formatTopUpAmt(topUpAmt)"> -->
                          <cTextInputComponent 
                          :isAmountField="true"
                           @onFocus="onRemoveCurrFormat(topUpAmt)"
                          @onBlur="formatTopUpAmt(topUpAmt)"
                          @onInput="onInputData"
                            v-model="topUpAmt"
                            :placeholder="$t('systemTopUpPage.topUpAmtPl')"
                            :rules="'required|max:'+getMaxCharacters(topUpAmt) +'|onlynumber|notValidNum'"
                          />
                              <!-- </div> -->
                         
                        </div>
                      </div>

                      <cTextInputComponent
                       @onInput="onInputData"
                        v-model="paymentRef"
                        :placeholder="$t('systemTopUpPage.paymentRef')"
                        :name="$t('systemTopUpPage.paymentRef')"
                        :maxLength="100"

                      />
                      <div class="float-right mt-15px mb-3px main-cta-btn">
                        <CButton color="danger" @click="onTopupCancel">{{$t('systemTopUpPage.cancel')}}</CButton>
                        <CButton type="submit" color="success">{{$t('systemTopUpPage.topUpBtn')}}</CButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <CAlert v-if="alertValue!=null" show color="danger">{{alertValue}}</CAlert> -->
            </CForm>
          </ValidationObserver>
          <cAlertModal v-if="isTopupDetConfirmed"
            :buttonList="[{
              name:$t('systemTopUpPage.noBtn'),func:onTopUpDetReject,color:'danger'},
                {name:$t('systemTopUpPage.yesBtn'),func:approveTopUp,color:'success'},]"
            :status="2"
            :show="isTopupDetConfirmed"
            :desc="$t('systemTopUpPage.rejectMsg',{currency:currencyCode.code,
            amount:$options.filters.formatNumber(topUpAmt,currencyCode.code),agent:agencyDet.agencyname,code:agencyDet.b2bcode})"
          ></cAlertModal>

          <cAlertModal 
            v-if="isTopupConfirmed"
            :buttonList="[{name:$t('systemTopUpPage.viewStatement'),func:onViewStatement,color:'info'},{name:$t('systemTopUpPage.ok'),func:confirmTopupModal,color:'success'}]"
            :status="1"
            :show="isTopupConfirmed"
            :desc="$t('systemTopUpPage.approveMsg',{code:currencyCode.code,amount:$options.filters.formatNumber(topUpAmt,currencyCode.code),agent:agencyDet.agencyname,b2bcode:agencyDet.b2bcode})"
          ></cAlertModal>

             <cAlertModal v-if="isTopupFailed&&alertValue"
                :show="isTopupFailed"
                :status="0"
                :buttonList="[ { name: this.$t('ticketNowPage.okBtn'), func:onHideFailedPopup, color: 'danger'} ]"
                :desc="alertValue"
        ></cAlertModal>
        </CCardBody>
      </CContainer>
    </CCard>
  </div>
</template>

<script>
import router, { navigate, goBack ,renewJWT, updateDataEdited} from "../router/index";

import apiGetAgentDetails from "../../src/services/apiGetAgentDetails.js";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import { COMPONENT_NAME, PATHNAME } from "@/util/constants.js";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../src/config/API_DATA";
import SERVICE_URL from "../../src/config/API_DATA";

import cDropDown from "../../src/components/form/cDropDown";

import { ValidationObserver, localize } from "vee-validate";

import apiSystemTopUp from "../../src/services/apiSystemTopUp.js";
import Logger from "../../src/services/logger";
import cTextInputComponent from "../../src/components/form/cTextInputComponent";
import cAgent from "../../src/components/form/cAgent";
import BaseConfiguration from "../../src/config/base.js";
import cAlertModal from "../../src/components/form/cAlertModal";
import {parseNumber, handleJWT, getErrorAlertValue ,addClassToBody,removeClassBody,getMaxCharOfAmount,removeCurrFormat} from "../../src/util/util";
import { APPROVEAGENT } from "../../src/util/constants.js";
// import nb from "../../src/translations/validation/nb.json";
// import en from "../../src/translations/validation/en.json";
import cAgentDetails from "../components/agentDetail/cAgentDetails";
import cAgentBalanceDetail from "../components/agentDetail/cAgentBalanceDetail";
import cAgentBookingDetail from "../components/agentDetail/cAgentBookingDetail";
import apiGetBalanceDetail from "../services/apiGetBalanceDetail";

// localize({
//   en: {
//     messages: en.messages
//   },
//   nb: {
//     messages: nb.messages
//   }
// });
export default {
  name: COMPONENT_NAME.SYSTEM_TOPUP,
  components: {
    ValidationObserver,
    cDropDown,
    cTextInputComponent,
    cAgent,
    cAlertModal,
    cAgentDetails,
    cAgentBalanceDetail,
    cAgentBookingDetail
  },
  data: () => ({

    agentType: APPROVEAGENT.PREPAID,
    isCurrChanged: true, ///bool value to re-create cDropDown while currency changed
    alertValue: null,
    isErrAlert: false,
    topUpAmt: null,
    paymentRef: null,
    agency: null,
    isTopupDetConfirmed: false, ///bool value to confirm details of Topup
    isTopupConfirmed: false, ///bool value to confirm the topup
    agencyDet: null,
    currencyCode: null,
    balanceDetail: null,
    isReCreateComp:true,
    // agentBookingDetail:{
    //   ticketQueue : 24,
    //   booking: 24,
    //   pending: 24
    // }
    isTopupFailed:false
  }),

  
  computed: {
    //  ...mapGetters("sCAgent", {
    //   agentDetails: "GET_AGENT_DETAIL_RES"
    //   // id : "GET_B2BID"
    // })
  },
  methods: {
            ...mapActions("sSystemTopUp", ["SET_SEL_AGENT_DEATAILS"]),
onInputData() {
    try {
      if(BaseConfiguration.isDebug) console.log("onInputData");
    updateDataEdited(true);

    } catch (err) {
            let body = Logger.buildRequest(
              FILE_NAME.SYSTEM_TOPUP,
              "error in onInputData",
              err.toString(),
              "onInputData",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
    
    }, 
       geTopupFailModalBtns() {
      
      return [
        {
          name: this.$t("ticketNowPage.okBtn"),
          func: this.onHideFailedPopup(),
          color: "danger"
        }
      ];
    },

    onHideFailedPopup() {
        try {
          if(BaseConfiguration.isDebug) console.log("onHideFailedPopup");
        this.isTopupFailed=false;
        this.isTopupConfirmed=false;
        this.isTopupDetConfirmed=false;
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.SYSTEM_TOPUP,
                  "error in onHideFailedPopup",
                  err.toString(),
                  "onHideFailedPopup",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 
    
    onViewStatement() {
        try {
          if(BaseConfiguration.isDebug) console.log("onViewStatement");
          this.SET_SEL_AGENT_DEATAILS(this.agencyDet)
         navigate(PATHNAME.TOPUP_REPORT);
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.SYSTEM_TOPUP,
                  "error in onViewStatement",
                  err.toString(),
                  "onViewStatement",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
       
        }, 
    
    onRemoveCurrFormat(pTopUpAmt) {
        try {
          if(BaseConfiguration.isDebug) console.log("onRemoveCurrFormat");
         
               this.topUpAmt= removeCurrFormat(pTopUpAmt);

        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.SYSTEM_TOPUP,
                  "error in onRemoveCurrFormat",
                  err.toString(),
                  "onRemoveCurrFormat",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        
        }, 

    getMaxCharacters(pTopUpAmt) {
        try {
          if(BaseConfiguration.isDebug) console.log("getMaxCharacters");
          let retMaxValue= getMaxCharOfAmount(pTopUpAmt);
        
        return retMaxValue;
        }
    
         catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.SYSTEM_TOPUP,
                  "error in getMaxCharacters",
                  err.toString(),
                  "getMaxCharacters",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

    
    // ///method to assign default agency
    // getDefaultAgency() {
    //     let defAgency = {
    //         b2bid: null,
    //         b2bcode: null,
    //         agencyname: null,
    //         contact_city: null,
    //         isactive: true
    //     };
    //     return defAgency;
    // },

    ///to cancel the topUp selection
    onTopupCancel() {
      try {
                  if(BaseConfiguration.isDebug) console.log("onTopupCancel");

        // this.selDetails.agentDetails = false;
        this.isTopupConfirmed = false;
        this.agency = null;
        this.agencyDet = null;
        this.topUpAmt = "";
        this.currencyCode = null;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SYSTEM_TOPUP,
          "error while cancel topup",
          err.toString(),
          "onTopupCancel",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///emit from cDropDown
    onSelectedCurrency(pCurrency) {
      try {
        this.currencyCode = pCurrency;
        this.formatTopUpAmt(this.topUpAmt);///to format existing amount while changing currency

      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SYSTEM_TOPUP,
          "error while emitting selected currency from cDropDown Component",
          err.toString(),
          "onSelectedCurrency",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to confirm the topup
    async confirmTopupModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("confirmTopupModal");
        // let retValue = await this.getAgentDetailsById(this.agencyDet);
        // if (retValue) {
        //   this.agencyDet = retValue;
        // }
         let retValue = await this.getBookingDetail(this.agencyDet.b2bid);
        if (retValue) {
          this.balanceDetail = retValue;
        }
        
        this.topUpAmt=null;
        this.paymentRef='';

       
        this.isTopupConfirmed = false;
        this.isTopupDetConfirmed = false;
        
         this.isReCreateComp = false;
        let that=this;

        setTimeout(function() {
          that.isReCreateComp = true;
        });
        
      // this.enableClickOnce();
        // this.alertValue = null;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SYSTEM_TOPUP,
          "error in confirmation",
          err.toString(),
          "confirmTopupModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
   

    ///method to get agent details from api
    async getAgentDetailsById(pAgencyDet) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log(" getAgentDetails");
        let getAgtDetReq = apiGetAgentDetails.buildRequest(pAgencyDet.b2bid);
        if (getAgtDetReq) {
          let getAgtDetRes = await apiGetAgentDetails.getResponse(getAgtDetReq);

          if (VALIDATE_SUCCESS_RES(getAgtDetRes)) {
            retValue = getAgtDetRes.data.data;
            if (this.agentDetails != null) {
              this.agencyDet = JSON.parse(
                JSON.stringify(this.agentDetails.data.data)
              ); //save the details of selected id
            }
          }
          // else if(getAgtDetRes.data.data){
          //     this.alertValue = getAgtDetRes.data.error[0];

          // }
          else {
            let error = getErrorMessage(getAgtDetRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_AGENT,
          "error in getting response from GetAgentDetails API",
          err.toString(),
          "getAgentDetailsById",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    ///emit from cAgentComponent
    getAgentDetails: async function(pAgentDetails) {
      try {
        if(pAgentDetails){
        if (BaseConfiguration.isDebug) console.log(" getAgentDetails");
        this.isCurrChanged = false;
        // this.alertValue = null; ///to clear a alert value if exist
        this.agencyDet = pAgentDetails;
        this.topUpAmt=null;
        this.paymentRef=null;
        
        if (this.agencyDet.b2bCompanyFinancess.length > 0) {
          this.currencyCode = this.agencyDet.b2bCompanyFinancess[0].currencycode;
          this.formatTopUpAmt(this.topUpAmt);///to format existing amount while changing agent
          this.balanceDetail = await this.getBookingDetail(this.agencyDet.b2bid); 

        } else {
          this.currencyCode = null;
        }
        let that = this;
        setTimeout(function() {
          that.isCurrChanged = true;
        });
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SYSTEM_TOPUP,
          "error while emitting agent details from cAgent Component",
          err.toString(),
          "getAgentDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

     async getBookingDetail(b2bid) {
          if(BaseConfiguration.isDebug) console.log("getBookingDetail");
          
      let returnValue;
      try {
        let balanceReq = apiGetBalanceDetail.buildRequest(b2bid);
        if (balanceReq) {
          let balanceRes = await apiGetBalanceDetail.getResponse(balanceReq);
          if (VALIDATE_SUCCESS_RES(balanceRes)) {
            returnValue = balanceRes.data.data;
          } else {
            let error = getErrorMessage(balanceRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            } 
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SYSTEM_TOPUP,
          "error in  getBookingDetail",
          err.toString(),
          " getBookingDetail()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    ///to get a currency code url
    getCurrencyCodeURL: function() {
      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencyCodeURL");
        return SERVICE_URL.GET_AGENT_SELECTED_CURRENCY;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SYSTEM_TOPUP,
          "error in currency code url",
          err.toString(),
          "getCurrencyCodeURL",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onTopUpDetConfirm() {
      try {
                if (BaseConfiguration.isDebug) console.log("onTopUpDetConfirm");

        if (this.agencyDet != null) {
          this.isTopupDetConfirmed = true;
        } else {
          this.isTopupDetConfirmed = false;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SYSTEM_TOPUP,
          "error in onTopUpDetConfirm",
          err.toString(),
          "onTopUpDetConfirm",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onTopUpDetReject() {
      try {
                        if (BaseConfiguration.isDebug) console.log("onTopUpDetReject");

        this.isTopupDetConfirmed = false;
        this.isTopupFailed=false;
        //  this.enableClickOnce();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SYSTEM_TOPUP,
          "error in onTopUpDetReject",
          err.toString(),
          "onTopUpDetReject",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    //to approve  topup selection
    async approveTopUp() {
      try {
        if (BaseConfiguration.isDebug) console.log("approveTopUp");

        if (this.agencyDet != null) {
          // b2bid=Number(this.agencyDet.b2bid.replace(/[^0-9]/g, ''));
          let topUpDet = {
            currency: this.currencyCode != null ? this.currencyCode.code : null,
            b2bid: parseNumber(this.agencyDet.b2bid),
            amount: parseNumber(this.topUpAmt),
            payment_reference: this.paymentRef
          };
          await this.getTopUpPrepaid(topUpDet);
          this.isTopupDetConfirmed=false;//to close yes/no popup

        } else {
          this.isTopupConfirmed = false;
        }
        updateDataEdited(false);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SYSTEM_TOPUP,
          "error while approving topup",
          err.toString(),
          "approveTopUp",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    // to make sure api will return value for top up object
    async getTopUpPrepaid(pTopUpDet) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log(" getTopUpPrepaid");
        let getTopUpDetReq = apiSystemTopUp.buildRequest(pTopUpDet);
        if (getTopUpDetReq) {
          let getTopUpDetRes = await apiSystemTopUp.getResponse(getTopUpDetReq);

          if (VALIDATE_SUCCESS_RES(getTopUpDetRes)) {
            retValue = getTopUpDetRes.data.data;
            this.isTopupConfirmed = true; ///if success,to make popup modal
          } else {
            this.isTopupDetConfirmed = false;
            let error = getErrorMessage(getTopUpDetRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
              if(this.alertValue){
                 this.isTopupFailed=true;
              }
            }
            // if (error && error.errorcode && error.errorcode == HTTP_CODES.ERROR_JWT && error.error) {
            //     // this.CLEAR_C_AGENT_STORE();
            //     // navigate(
            //     //     path: PATHNAME.SYSTEM_LOGIN,
            //     //     query: {
            //     //         param: [HTTP_CODES.ERROR_JWT, error.error[0]]
            //     //     }
            //     // });
            //     this.alertValue = error.error[0].value;

            // } else if (error && error.error[0].value) {

            //     this.alertValue = error.error[0].value;
            // } else {
            //     this.alertValue = "Failed";
            // }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SYSTEM_TOPUP,
          "error in getting response from GetAgentDetails API",
          err.toString(),
          "getAgentDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    formatTopUpAmt(pTopUpAmt) {
     if (BaseConfiguration.isDebug) console.log(" formatTopUpAmt");
      try {
        // if(val&&!(val.includes('.00')))
        // {
        // var value=  Number(val.replace(/[^0-9\.]/g, ""))

        // this.topUpAmt = this.$options.filters.formatNumber(value,"deci");
        // console.log(this.topUpAmt);

        // }else{
          if(this.currencyCode)
        {
           this.topUpAmt= this.$options.filters.currencyFormat(pTopUpAmt,this.currencyCode.code);
        }
        else{
          throw "invalid currency selection";
        }

        // }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SYSTEM_TOPUP,
          "error in formatTopUpAmt",
          err.toString(),
          "formatTopUpAmt",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
   
  },

  created() {
    // this.agency = this.getDefaultAgency();
  },
//   watch: {
//     ///to format amount in V-Model using filter method
//     topUpAmt(val) {
//       try {
//         if (BaseConfiguration.isDebug) console.log(" topUpAmt");
//  if(val&&!(val.includes('.')))
//         {
//         this.topUpAmt = this.$options.filters.formatNumber(val);

//         }
//       } catch (err) {
//         let body = Logger.buildRequest(
//           FILE_NAME.SYSTEM_TOPUP,
//           "error while formatting  amount in V-Model using filter method",
//           err.toString(),
//           "changeValue",
//           LOG_TYPE.ERROR
//         );
//         Logger.getResponse(body);
//       }
//     }
//   },
     beforeCreate() {    
   addClassToBody(COMPONENT_NAME.SYSTEM_TOPUP);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
};
</script>

<style>
.pre-formatted {
  white-space: pre;
}

.btn-na:active,
.btn-na.active,
.btn-na:focus,
.btn-na.focus {
  background-color: lightgreen !important;
}

.btn:active {
  background: #b5f0a3;
}

.radio-style {
  margin-left: 30px;
}

.radio-margin {
  margin-left: 150px;
}

.postpaidCard {
  /* background: #1877a5; */
  background: #b5f0a3;
}
</style>
